var map = {
	"./X33-Mall_small.jpg": 906,
	"./all-active.svg": 907,
	"./all.svg": 908,
	"./apple-watch.png": 909,
	"./b-headphone.png": 910,
	"./coin.svg": 911,
	"./delete-btn.svg": 912,
	"./iphone-pink.png": 913,
	"./love-active.svg": 914,
	"./love.svg": 915,
	"./mobile-bg.jpg": 916,
	"./price-high-active.svg": 917,
	"./price-high.svg": 918,
	"./price-low-active.svg": 919,
	"./price-low.svg": 920,
	"./shopping-cart.svg": 921,
	"./star.svg": 922,
	"./x33mall-banner-cn.jpg": 923,
	"./x33mall-banner-id.jpg": 924,
	"./x33mall-banner-ms.jpg": 925,
	"./x33mall-banner.jpg": 926
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 154;